import React from 'react';
import ImageWithCache from './ImageWithCache';
import './SavingsPage.css';

const SavingsPage = () => {
  return (
    <div className="savings-page">
      <div className="savings-content">
        <div className="savings-hero">
          <div className="savings-hero-top">
            <div className="savings-hero-icon-spacer" />
            <p className="savings-hero-title">Накопичення</p>
            <ImageWithCache className="savings-hero-icon" src="/safe-icons/safe-info.webp" alt="Інформація" />
          </div>
          <p className="savings-hero-subtitle">Ви можете оформити депозити, придбати <br />облігації або створити свою Банку</p>
        </div>

        <div className="savings-card savings-card-big">
          <div className="savings-card-icon">
            <ImageWithCache className="savings-card-icon-img" src="/safe-icons/safe-icon.webp" alt="Відкрити депозит" />
          </div>
          <p className="savings-card-title">Відкрити<br />депозит</p>
        </div>

        <div className="savings-row">
          <div className="savings-card savings-card-small">
            <div className="savings-card-icon">
              <ImageWithCache className="savings-card-icon-img" src="/safe-icons/safe-jar.webp" alt="Відкрити Банку" />
            </div>
            <p className="savings-card-title">Відкрити<br />Банку</p>
          </div>
          <div className="savings-card savings-card-small">
            <div className="savings-card-icon">
              <ImageWithCache className="savings-card-icon-img" src="/safe-icons/safe-gerb.webp" alt="Купити облігації" />
            </div>
            <p className="savings-card-title">Купити<br />облігації</p>
          </div>
        </div>

        <div className="savings-archive-pill">
          <ImageWithCache className="savings-archive-icon" src="/safe-icons/safe-archive.webp" alt="" />
          <p className="savings-archive-text">Переглянути архів</p>
        </div>
      </div>
    </div>
  );
};

export default SavingsPage;
